var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_47_",
    "data-name": "svgexport-6 (47)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M203.311,219.475a1.418,1.418,0,0,0-.212.271l-.667,1.108-.495.495a.354.354,0,0,0,.012.512.36.36,0,0,0,.495-.019l.487-.487,1.108-.667a1.417,1.417,0,0,0,.271-.212l.378-.378-1-1Zm0,0",
    transform: "translate(-197.113 -213.972)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M441.075,31.207a.707.707,0,1,0-1-1l-.5.5,1,1Zm0,0",
    transform: "translate(-429.283 -29.292)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10654",
    "data-name": "Path 10654",
    d: "M301.684,83.966l2.751-2.751,1,1-2.751,2.751Zm0,0",
    transform: "translate(-294.643 -79.317)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10655",
    "data-name": "Path 10655",
    d: "M10.728,10.7V8.789L8.789,10.7Zm0,0",
    transform: "translate(-8.582 -8.582)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10656",
    "data-name": "Path 10656",
    d: "M1.42,12a1.427,1.427,0,0,0,1.41-1.428V9.539a.351.351,0,0,1,.351-.352H9.17V5.5L7.675,7s-.3.256-.4.315l-1.026.619-.43.431a1.04,1.04,0,0,1-1.4.071H1.787a.358.358,0,0,1-.36-.335.351.351,0,0,1,.351-.368H4.031a1.06,1.06,0,0,1-.011-.113,1.049,1.049,0,0,1,.18-.59H1.787a.358.358,0,0,1-.36-.335.351.351,0,0,1,.351-.368h3.05l.422-.7H1.787a.358.358,0,0,1-.36-.335.351.351,0,0,1,.351-.368h4l.7-.7h-4.7a.358.358,0,0,1-.36-.335.351.351,0,0,1,.351-.368H7.185l.7-.7H3.893a.358.358,0,0,1-.36-.335.351.351,0,0,1,.351-.368H8.589l.581-.582V.352A.351.351,0,0,0,8.819,0H2.83V2.461a.351.351,0,0,1-.351.352H0v7.781A1.425,1.425,0,0,0,1.42,12Zm0,0",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10657",
    "data-name": "Path 10657",
    d: "M128.146,422v.707a2.106,2.106,0,0,1-.552,1.415h6.588a1.061,1.061,0,0,0,1.061-1.061v-.707a.354.354,0,0,0-.354-.354Zm0,0",
    transform: "translate(-124.658 -412.122)",
    fill: "#6a6f73"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/description-icon.96c30fcf122d04ec64ba71428e01d03d.svg";
export { ForwardRef as ReactComponent };